import React from 'react';
import { Newspaper } from 'lucide-react';
export function HeroSection() {
  return <section className="relative py-24 md:py-32 flex items-center border-b border-brand-gray-800 overflow-hidden tactical-grid" data-id="element-204">
      <div className="absolute inset-0 bg-gradient-to-b from-brand-black/50 via-brand-black/40 to-brand-black z-[1]" data-id="element-205" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full text-center" data-id="element-206">
        <div className="inline-flex items-center gap-2 px-3 py-1 border border-brand-teal/30 bg-brand-teal/10 text-brand-teal text-xs font-bold uppercase tracking-widest mb-6" data-id="element-207">
          <Newspaper className="w-4 h-4" data-id="element-208" />
          News & Insights
        </div>
        <h1 className="text-4xl md:text-6xl font-extrabold text-brand-white tracking-tight leading-tight mb-6 uppercase" data-id="element-209">
          Blog
        </h1>
        <p className="text-xl text-brand-gray-400" data-id="element-210">
          Updates, insights, and expertise from Medina Tactical Dynamics
        </p>
      </div>
    </section>;
}